import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { ROUTE_CONSTANTS } from '../constants/route.constant';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthApiService } from '@app/modules/auth/services/auth-api/auth-api.service';

/**
 * Guard that prevents access to a route if the user is already authenticated.
 * Used to restrict login/register pages for logged-in users.
 */
@Injectable({
    providedIn: 'root',
})
export class AuthGuestGuard implements CanActivate, CanActivateChild {
    constructor(
        private readonly authService: AuthApiService,
        private readonly router: Router
    ) {}

    canActivate(): Observable<boolean | UrlTree> {
        return this.checkAccess();
    }

    canActivateChild(): Observable<boolean | UrlTree> {
        return this.checkAccess();
    }

    private checkAccess(): Observable<boolean | UrlTree> {
        return this.authService.user$.pipe(
            map((user) => {
                return !user ? true : this.router.createUrlTree([ROUTE_CONSTANTS.HOME]);
            }),
            catchError(() => {
                // User not authenticated – allow access
                return of(true);
            })
        );
    }
}
